import React from 'react';
import styled from 'styled-components';

const stats = [
  {
    value: '20+',
    title: 'Investor Partners'
  },
  {
    value: '50+',
    title: 'Mentor & Industry Experts'
  },
  {
    value: '$1M+',
    title: 'Funds successfully closed'
  },
  {
    value: '100+',
    title: 'Value Partners'
  }
];

const StatsHighlights: React.FC = () => {
  return (
    <Section>
      <Label>Trusted By Top Investors & Founders</Label>
      <StatsGrid>
        {stats.map((stat) => (
          <StatCard key={stat.title}>
            <Value>{stat.value}</Value>
            <Title>{stat.title}</Title>
          </StatCard>
        ))}
      </StatsGrid>
    </Section>
  );
};

const Section = styled.section`
  background: #fafafa;
  padding: 30px 24px;
  text-align: center;
`;

const Label = styled.span`
  display: inline-flex;
  padding: 8px 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgb(255, 255, 255), rgba(255, 126, 27, 0.1));
  color: #ff5924;
  border: 0.05px solid rgba(255, 157, 133,0.5) ;
  box-shadow: 0 0px 50px rgba(162, 42, 1, 0.1);
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 32px;
`;

const StatsGrid = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const StatCard = styled.article`
  border-radius: 16px;
  padding: 40px 32px;
  text-align: center;
  border: 1px solid rgba(17, 28, 43, 0.08);
  box-shadow: 0 15px 50px rgba(17, 28, 43, 0.01);
  position: relative;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  background: #ffffff;
  border: 0.5px solid rgba(255, 91, 36, 0.3);
  box-shadow: 0 10px 10px rgba(162, 42, 1, 0.1);
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 25px 55px rgba(255, 89, 36, 0.2);
    border-color: #ff5924;
  }
`;

const Value = styled.span`
  font-size: 48px;
  font-weight: 700;
  display: block;
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: rgba(17, 28, 43, 0.75);
`;

export default StatsHighlights;
